var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 6H21.6V8H3.59998V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 11H21.6V13H3.59998V11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 16H21.6V18H3.59998V16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.73bd9a7e484eadb320ad69ef4f544d94.svg";
export { ForwardRef as ReactComponent };